export default "__VITE_ASSET__wKoSb7$E__"